import { NODE_URL } from "@src/constants";

interface ISettingsStorageData {
  customNode?: string;
  backendUrl?: string;
}

export const normalizeUrl = (url: string): string => {
  let normalizedUrl = url.trim();
  if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
    normalizedUrl = 'https://' + normalizedUrl;
  }
  if (normalizedUrl.endsWith('/')) {
    normalizedUrl = normalizedUrl.slice(0, -1);
  }
  return normalizedUrl;
};

export const getNodeUrl = (): string => {
  const storageData = localStorage.getItem("puzzle-user-settings");
  if (storageData) {
    const settings: ISettingsStorageData = JSON.parse(storageData);
    if (settings.customNode && settings.customNode.trim()) {
      return normalizeUrl(settings.customNode);
    }
  }
  return NODE_URL;
};

export const hasCustomNode = (): boolean => {
  const storageData = localStorage.getItem("puzzle-user-settings");
  if (storageData) {
    const settings: ISettingsStorageData = JSON.parse(storageData);
    return !!(settings.customNode && settings.customNode.trim());
  }
  return false;
};

export const getBackendUrl = (): string => {
  const storageData = localStorage.getItem("puzzle-user-settings");
  if (storageData) {
    const settings: ISettingsStorageData = JSON.parse(storageData);
    if (settings.backendUrl && settings.backendUrl.trim()) {
      return normalizeUrl(settings.backendUrl);
    }
  }
  return process.env.REACT_APP_API_BASE || '';
};

export const hasCustomBackend = (): boolean => {
  const storageData = localStorage.getItem("puzzle-user-settings");
  if (storageData) {
    const settings: ISettingsStorageData = JSON.parse(storageData);
    return !!(settings.backendUrl && settings.backendUrl.trim());
  }
  return false;
};
